import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import React, { useState } from "react";
import { ProductItemTableOrder } from "../components/ProductItemTableOrder";
import { PizzaDialog } from "./PizzaDialog";

let product = {};

export const DealProductsDialog = (props) => {
  const {
    open,
    onClose,
    pizzaSizeId,
    dealProducts,
    onAddProduct,
    currDealIndex,
    showLoader,
    closeLoader,
  } = props;
  const [openProduct, setOpenProduct] = useState(false);

  const handleOpenProduct = async (productId) => {
    const selectedProduct = {
      ...dealProducts.find((x) => x.productId == productId),
    };
    selectedProduct.quantity = 1;
    selectedProduct.totalPrice = parseFloat(selectedProduct.price);
    selectedProduct.notes = "";
    product = selectedProduct;
    setOpenProduct(true);
  };

  const handleAddProduct = (product) => {
    onAddProduct(currDealIndex, product);
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Choose a Pizza</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          {dealProducts.map((product, index) => {
            let price = product.price;
            var specialPrice = product.productSpecialPricings.find(
              (x) => x.fromQty === 1
            );
            if (specialPrice) {
              price = specialPrice.specialPrice;
            }
            return (
              <ProductItemTableOrder
                key={index}
                id={product.productId}
                name={product.productName}
                description={product.productDescription}
                price={price || 0}
                imageUrl={
                  product.imageUrl ? product.imageUrl : product.imageUrl2
                }
                rows={12}
                onOpen={async () => await handleOpenProduct(product.productId)}
              />
            );
          })}
        </Grid>
        {openProduct ? (
          <PizzaDialog
            open={openProduct}
            product={product}
            defaultPizzaSizeId={pizzaSizeId}
            onProductAdd={handleAddProduct}
            onClose={() => setOpenProduct(false)}
            showLoader={() => showLoader()}
            closeLoader={() => closeLoader()}
          />
        ) : null}
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "flex-start" }}>
        <Button color="error" onClick={() => onClose()}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
